import { PropsWithChildren } from 'react'
import { ThemeProvider as SCThemeProvicer } from 'styled-components'
import { theme } from './theme'

export const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return <SCThemeProvicer theme={theme}>{children}</SCThemeProvicer>
}
